import React, { useEffect, useState } from "react";
import { LinkTreeItem } from "../common/LinkTree";
import { Alert, AlertVariant, Grid, ProgressBar } from "react-unity";
import TextInputField from "../common/form-controls/TextInputField";
import RequestFormWrapper from "../common/wrappers/RequestFormWrapper";
import SubscriptionRequest from "../../models/entities/SubscriptionRequest";
import ToggleField from "../common/form-controls/ToggleField";
import ReactButton from "../common/ReactButton";
import SubscriptionRequestsService from "../../services/SubscriptionRequestsService";
import SelectField from "../common/form-controls/SelectField";
import { useNavigate, useParams } from 'react-router-dom';
import { AbstractFormState } from "../common/AbstractForm";
import VMPatchingSchduleOptions from "./components/VMPatchingScheduleOptions";
import { VirtualNetwork } from "../../models/entities/AzureResources/VirtualNetwork";
import { VirtualMachineModel } from "../../models/viewModels/Subscriptions/VMProvisioningModel";
import Select, { StylesConfig } from "react-select";
import './VirtualMachineRequestCreate.css';
import { AlertBanner } from "../../models/interfaces/AlertBanner";
import AlertModal from "../common/modals/AlertModal";
import Exception from "../../models/viewModels/Exception";
import VirtualMachineRequestService from "../../services/VirtualMachineRequestService";

interface VirtualMachineRequestProps {
}

interface TOptions {
	value: string;
	text: string;
	id?: string;
}

interface IOption {
	value: number;
	label: string;
}

const VirtualMachineRequestCreate = (props: VirtualMachineRequestProps) => {

	const { subsId } = useParams<{ subsId: string }>();
	const [subscription, setSubscription] = useState<SubscriptionRequest>();
	const [vNets, setVNets] = useState<VirtualNetwork[]>();
	const [vNetOptions, setVNetOptions] = useState<TOptions[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [loadingPermissions, setLoadingPermissions] = useState<AlertBanner>({ visible: false });
	const [hasPermissions, setHasPermissions] = useState<boolean>(false);
	const [showVMName, setShowVMName] = useState<boolean>(true);
	const [resourceGroupsOptions, setResoruceGroupsOptions] = useState<TOptions[]>([]);
	const [subnetsOptions, setSubnetsOptions] = useState<TOptions[]>([]);
	const [publishersOptions, setPublishersOptions] = useState<TOptions[]>([]);
	const [offersOptions, setOffersOptions] = useState<TOptions[]>([]);
	const [SKUsOptions, setSKUsOptions] = useState<TOptions[]>([]);
	const [vmSizesOptions, setVMSizesOptions] = useState<TOptions[]>([]);
	const [recoveryServicesOptions, setRecoveryServicesOptions] = useState<TOptions[]>([]);
	const [backupPoliciesOptions, setBackupPolicies] = useState<TOptions[]>([]);
	const [diskSizesOptions, setDiskSizesOptions] = useState<IOption[]>([]);
	const [azureBackupOptions, setAzureBackupOptions] = useState<TOptions[]>([
		{ value: 'Enable', text: 'Enabled' },
		{ value: 'Disable', text: 'Disabled' }
	]);
	const [operatingSystemSelected, setOperatingSystemSelected] = useState<string>('');
	const [submissionAlert, setSubmissionAlert] = useState<AlertBanner>({ visible: false });
	const [endModal, setEndModal] = useState<AlertBanner>({ visible: false });
	const subscriptionService = new SubscriptionRequestsService();
	const virtualMachineRequestService = new VirtualMachineRequestService();
	const navigate = useNavigate();
	const [state, setState] = useState<AbstractFormState<VirtualMachineModel>>({
		stateForm: {
			vmName: [''],
			subscriptionName: '',
			resourceGroup: '',
			applicationName: '',
			environment: '',
			virtualNetworkId: '',
			virtualNetwork: '',
			subnetName: '',
			serverNamePrefix: '',
			numberOfVMs: 1,
			startingNumber: 1,
			publisher: '',
			offer: '',
			SKU: '',
			version: '',
			serviceLevel: '',
			location: '',
			vmSize: '',
			diskType: '',
			diskSize: 0,
			availabilityOption: '',
			availabilityZone: '',
			recoveryServices: '',
			backupPolicy: '',
			backupVaultId: '',
			azureBackup: '',
			patchMode: 'UserProvidedSchedule',
			patchSchedule: '',
			imageOS: 'Windows',
		}
	});
	const [loadingDiskSize, setLoadingDiskSize] = useState<boolean>(false);
	const VMStyles: StylesConfig<any, false> = {
		control: (css) => ({
			...css,
			borderColor: state?.stateForm?.diskSize === 0 && 'rgb(202, 106, 114)!important',
			background: `${stateFormHandler().diskSize.isDisabled ? `var(--paletteDisabledLight, #f5f5f5)` : `inherit`}!important`,
		}),
	};

	const resetForm = () => {
		handleStateFormChange('vmName', '');
		handleStateFormChange('applicationName', '');
		handleStateFormChange('environment', '');
		handleStateFormChange('virtualNetwork', '');
		handleStateFormChange('subnetName', '');
		handleStateFormChange('serverNamePrefix', '');
		handleStateFormChange('numberOfVMs', 1);
		handleStateFormChange('startingNumber', 1);
		handleStateFormChange('location', '');
		handleStateFormChange('serviceLevel', '');
		handleStateFormChange('publisher', '');
		handleStateFormChange('offer', '');
		handleStateFormChange('SKU', '');
		handleStateFormChange('vmSize', '');
		handleStateFormChange('diskType', '');
		handleStateFormChange('diskSize', 0);
		handleStateFormChange('availabilityOption', '');
		handleStateFormChange('availabilityZone', '');
		handleStateFormChange('recoveryServices', '');
		handleStateFormChange('backupPolicy', '');
		handleStateFormChange('azureBackup', '');
		handleStateFormChange('patchMode', 'UserProvidedSchedule');
		handleStateFormChange('patchSchedule', '');
		handleStateFormChange('imageOS', 'Windows');
	}

	const handleSubmitRequest = async () => {
		window.scroll(0, 0);
		try {
			let finalName: string[] = [];
			for (let index = 0; index < stateFormHandler().numberOfVMs.value; index++) {
				const number = parseInt(stateFormHandler().startingNumber.value.toLocaleString()) + index;
				finalName = [...finalName, getVMFinalName(number.toLocaleString())];
			}
			handleStateFormChange('vmName', finalName);
			handleStateFormChange('imageOS', operatingSystemSelected);
			setLoadingPermissions({
				visible: true,
				variant: 'default',
				text: `Checking for duplicated names in Azure`
			});
			await virtualMachineRequestService.checkDuplicatedNames(finalName);
			setLoading(true);
			const model = new VirtualMachineModel(state.stateForm);
			const res = await virtualMachineRequestService.createVM(subscription.id, model);
			setSubmissionAlert({
				visible: true,
				variant: 'success',
				text: 'Virtual Machine successfully requested.'
			});
		} catch (ex) {
			const exception = new Exception(ex);
			setSubmissionAlert({
				visible: true,
				variant: 'error',
				text: `Something went wrong. ${exception?.response.data.message}`
			});
		} finally {
			setLoadingPermissions({
				visible: false
			});
			setLoading(false);
		}
	};

	const handleStateFormChange = (field, value): void => {
		const fields = [].concat(...[field]);
		const values = !Array.isArray(field) ? [value] : value;
		const form = state.stateForm;
		fields.forEach((fieldName, index) => {
			form[fieldName] = values[index];
		});
		setState({ stateForm: form });
	};

	const stateFormHandler = () => getStateFormHandlers();

	const getStateFormHandlers = () => {
		return {
			vmName: {
				value: state.stateForm.vmName,
				validation: {
					required: () => false
				},
				onChange: (event) => {
					handleStateFormChange('vmName', event.target.value);
				}
			},
			subscriptionName: {
				value: state.stateForm.subscriptionName,
				options: [
					{ value: subscription?.createdSubscriptionName, text: subscription?.createdSubscriptionName }
				],
				disabled: true,
				validation: {
					required: () => true
				},
				onChange: (event) => {
					handleStateFormChange('subscriptionName', event.target.value);
				}
			},
			resourceGroups: {
				value: state.stateForm?.resourceGroup,
				options: resourceGroupsOptions,
				disabled: loadingPermissions.visible,
				validation: {
					required: () => true,
					rules: [
						{
							assert: () => !hasPermissions == false,
							message: 'You do not have permissions in this resource Group'
						}
					]
				},
				onChange: (event) => {
					handleResourceGroupChange(event.target.value);
					resetForm()
				}
			},
			applicationName: {
				value: state.stateForm?.applicationName,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
					rules: [
						{
							assert: () => state.stateForm.applicationName.length < 256,
							message: 'Application Name can\'t be longer than 256 characters'
						}
					]
				},
				onChange: async (event) => {
					handleStateFormChange('applicationName', event.target.value);
				}
			},
			environment: {
				value: state.stateForm?.environment,
				disabled: !hasPermissions,
				validation: {
					required: () => true
				},
				options: [
					{ value: 'Development', text: 'Development' },
					{ value: 'Acceptance', text: 'Acceptance' },
					{ value: 'Production', text: 'Production' }
				],
				onChange: (event) => {
					handleStateFormChange('environment', event.target.value);
					handleStateFormChange('azureBackup', event.target.value == 'Production' && 'Enable');
				}
			},
			virtualNetwork: {
				value: state.stateForm?.virtualNetwork,
				options: vNetOptions,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				onChange: (event) => {
					handleStateFormChange('virtualNetwork', event.target.value);
					handleStateFormChange('virtualNetworkId', event.target.value);
					fetchSubnets(event.target.value)
				}
			},
			subnetName: {
				value: state.stateForm?.subnetName,
				validation: {
					required: () => true
				},
				disabled: !state.stateForm.virtualNetwork || !hasPermissions,
				options: subnetsOptions,
				onChange: (event) => {
					handleStateFormChange('subnetName', event.target.value);
				}
			},
			serverNamePrefix: {
				value: state.stateForm?.serverNamePrefix,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
					rules: [
						{
							assert: () => state.stateForm.serverNamePrefix.length == 3,
							message: 'The prefix must be 3 characters of length'
						}
					]
				},
				onChange: (event) => {
					handleStateFormChange('serverNamePrefix', event.target.value);
					if (event.target.value.length > 2 && event.target.value.length < 6) handleStartingNumnerChange();
				}
			},
			numberOfVMs: {
				value: state.stateForm?.numberOfVMs,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
					rules: [
						{
							assert: () => state.stateForm.numberOfVMs <= 10,
							message: 'The number of VMs must be less than 10'
						}
					]
				},
				onChange: (event) => {
					handleStateFormChange('numberOfVMs', event.target.value);
				}
			},
			startingNumber: {
				value: state.stateForm?.startingNumber,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				onChange: (event) => {
					handleStateFormChange('startingNumber', event.target.value);
				}
			},
			location: {
				value: state.stateForm?.location,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				options: [
					{ value: 'chinanorth3', text: 'China North 3' }
				],
				onChange: (event) => {
					handleStateFormChange('location', event.target.value);
					setLoadingDiskSize(true);
					fetchVMPublishers();
					fetchVMSizes();
				}
			},
			serviceLevel: {
				value: state.stateForm?.serviceLevel,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				options: [
					{ value: '0', text: '0' },
					{ value: '1', text: '1' },
					{ value: '2', text: '2' },
					{ value: '3', text: '3' },
				],
				note: (state.stateForm.environment == 'Development' || state.stateForm.environment == 'Production') ? `For ${state.stateForm.environment} is recommended to select ${state.stateForm.environment == 'Development' ? '0' : '1'}` : '',
				onChange: (event) => {
					handleStateFormChange('serviceLevel', event.target.value);
				}
			},
			publisher: {
				value: state.stateForm?.publisher || '',
				validation: {
					required: () => true,
				},
				loading: publishersOptions.length == 0,
				loadingText: 'Loading Publishers...',
				disabled: state.stateForm?.location == '' || !hasPermissions,
				options: publishersOptions,
				onChange: (event) => {
					handleStateFormChange('offer', '');
					handleStateFormChange('SKU', '');
					setOffersOptions([]);
					setSKUsOptions([]);
					handleStateFormChange('publisher', event.target.value);
					const os = publishersOptions[event.target.selectedIndex - 1].id;
					setOperatingSystemSelected(os)
					fetchVMOffers(os);
				}
			},
			offer: {
				value: state.stateForm?.offer,
				validation: {
					required: () => true,
				},
				loading: offersOptions.length == 0,
				loadingText: 'Loading Offers...',
				disabled: state.stateForm?.publisher == '' || !hasPermissions,
				options: offersOptions,
				onChange: (event) => {
					handleStateFormChange('offer', event.target.value);
					fetchSKUs(operatingSystemSelected);
				}
			},
			SKU: {
				value: state.stateForm?.SKU,
				validation: {
					required: () => true,
				},
				loading: SKUsOptions.length == 0,
				loadingText: 'Loading SKUs...',
				disabled: state.stateForm?.offer == '' || !hasPermissions,
				options: SKUsOptions,
				onChange: (event) => {
					handleStateFormChange('SKU', event.target.value);
				}
			},
			vmSize: {
				value: state.stateForm?.vmSize,
				validation: {
					required: () => true,
				},
				disabled: state.stateForm?.location == '' || !hasPermissions,
				options: vmSizesOptions,
				onChange: (event) => {
					handleStateFormChange('vmSize', event.target.value);
				}
			},
			diskType: {
				value: state.stateForm?.diskType,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				options: [
					{ value: 'Standard_LRS', text: 'Standard HDD' },
					{ value: 'StandardSSD_LRS', text: 'Standard SSD' },
					{ value: 'Premium_LRS', text: 'Premium SSD' }
				],
				onChange: (event) => {
					handleStateFormChange('diskType', event.target.value);
					fetchDiskSize();
				}
			},
			diskSize: {
				value: { value: state.stateForm?.diskSize, label: state.stateForm.diskSize.toLocaleString() },
				validation: {
					required: () => true,
				},
				placeholder: '',
				isDisabled: state.stateForm?.diskType === '' || state.stateForm?.location === '' || !hasPermissions,
				isLoading: loadingDiskSize,
				options: diskSizesOptions,
				onChange: (event: IOption) => {
					handleStateFormChange('diskSize', event.value);
				}
			},
			availabilityOption: {
				value: state.stateForm?.availabilityOption,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				options: [
					{ value: 'Availability zone', text: 'Availability zone' },
					{ value: 'Disabled', text: 'Disabled' },
				],
				onChange: (event) => {
					handleStateFormChange('availabilityOption', event.target.value);
				}
			},
			availabilityZone: {
				value: state.stateForm?.availabilityZone,
				validation: {
					required: () => state.stateForm?.availabilityOption !== 'Disabled',
				},
				disabled: state.stateForm?.availabilityOption === 'Disabled' || !hasPermissions,
				options: [
					{ value: '1', text: 'Zone 1' },
					{ value: '2', text: 'Zone 2' },
					{ value: '3', text: 'Zone 3' }
				],
				onChange: (event) => {
					handleStateFormChange('availabilityZone', event.target.value);
				}
			},
			recoveryServices: {
				value: state.stateForm?.recoveryServices,
				options: recoveryServicesOptions,
				disabled: !hasPermissions,
				validation: {
					required: () => state.stateForm?.azureBackup == 'Enable' || state.stateForm?.environment == 'Production'
				},
				onChange: (event) => {
					handleStateFormChange('recoveryServices', event.target.value);
					handleStateFormChange('backupVaultId', recoveryServicesOptions[event.target.selectedIndex - 1].id);
					fetchBackupPolicies(event.target);
				}
			},
			backupPolicy: {
				value: state.stateForm?.backupPolicy,
				options: backupPoliciesOptions,
				disabled: state.stateForm?.recoveryServices == '' || !hasPermissions,
				validation: {
					required: () => state.stateForm?.azureBackup == 'Enable'
				},
				onChange: (event) => {
					handleStateFormChange('backupPolicy', event.target.value);
				}
			},
			azureBackup: {
				value: state.stateForm?.azureBackup,
				disabled: !hasPermissions,
				validation: {
					required: () => true,
				},
				options: azureBackupOptions,
				onChange: (event) => {
					handleStateFormChange('azureBackup', event.target.value);
				}
			},
			patchMode: {
				value: state.stateForm?.patchMode,
				disabled: !hasPermissions,
				validation: {
					required: () => state.stateForm?.azureBackup == 'Enable'
				},
				options: [
					{ value: 'UserProvidedSchedule', text: 'Update Manager by tag' },
				],
				onChange: (event) => {
					handleStateFormChange('patchMode', event.target.value);
				}
			},
			patchSchedule: {
				value: state.stateForm?.patchSchedule,
				disabled: !hasPermissions,
				validation: {
					required: () => state.stateForm?.azureBackup == 'Enable',
				},
				options: VMPatchingSchduleOptions,
				onChange: (event) => {
					handleStateFormChange('patchSchedule', event.target.value);
				}
			}
		};
	};

	const CustomOptionDiskSize = (props: { data: any; innerRef: any; innerProps: any; }) => {
		const { data, innerRef, innerProps } = props;
		return (
			<div
				style={{ background: `${data.isDisabled ? '#f5f5f5' : '#999'}` }}
				ref={innerRef}
				{...innerProps}
				className='custom-option-box'
			>
				<div className='custom-option' style={{ color: `${data.isDisabled ? '#f5f5f5' : '#999'}` }}>{data.isLoading ? data.loadingMessage : data.label}</div>
			</div>
		);
	};

	const handleResourceGroupChange = async (resoruceGroupName: string) => {
		handleStateFormChange('resourceGroup', resoruceGroupName);
		setLoadingPermissions({ visible: true, text: 'Verifying Permissions' });
		const id = parseInt(subsId);
		try {
			await subscriptionService.getPermissionsInSubscription(id, resoruceGroupName);
			setHasPermissions(true);
		} catch (e) {
			setHasPermissions(false);
		}
		setLoadingPermissions({ visible: false });
	}

	const handleStartingNumnerChange = async () => {
		const vmNumber = (await virtualMachineRequestService.getStartingNumberByPrefix(
			subscription.createdSubscriptionId, state.stateForm?.environment, state.stateForm?.serverNamePrefix));
		handleStateFormChange('startingNumber', vmNumber);
	};

	const fetchRecoveryServicesBySubscription = async () => {
		handleStateFormChange('recoveryServices', '');
		const id = parseInt(subsId);
		const options = [];
		const recoverySer = await subscriptionService.getAllRecoveryServicesByResourceGroupInSubscription(id);
		recoverySer.map(res =>
			options.push({ value: res.name, text: res.name, id: res.id })
		);
		setRecoveryServicesOptions(options);
	}

	const fetchDiskSize = async () => {
		const diskSizes = await subscriptionService.getAllDiskSizesByLocationInSubscription(
			subscription.id,
			stateFormHandler().location.value,
			stateFormHandler().diskType.value
		);
		diskSizes.sort((a, b) => { return parseInt(a) - parseInt(b) });
		const options = [];
		diskSizes.map(res => options.push({ value: parseInt(res), label: res }));
		setDiskSizesOptions(options);
		setLoadingDiskSize(false);
	};

	const fetchBackupPolicies = async (target: any) => {
		handleStateFormChange('backupPolicy', '');
		const str = recoveryServicesOptions[target.selectedIndex - 1].id;
		const parts = str.split('/');
		const resourceGroupName = parts[4];
		const backup = await subscriptionService.getAllBackupPoliciesInSubscription(
			subscription.id,
			resourceGroupName,
			stateFormHandler().recoveryServices.value
		);
		const options = [];
		backup.map(res => options.push({ value: res.name, text: res.name, id: res.id }));
		setBackupPolicies(options);
	};

	const fetchVMPublishers = async () => {
		const [linuxPublishers, windowsPublishers] = await Promise.all([
			subscriptionService.getAllLinuxPublishers(),
			subscriptionService.getAllPublishersByLocationInSubscription(subscription.id, stateFormHandler().location.value)
			]);
		const options = [];

		linuxPublishers.map(res => {
			options.push({ value: res, text: res, id: "Linux" })
		});

		windowsPublishers.map(res => {
			options.push({ value: res.name, text: res.name, id: "Windows" })
		});

		setPublishersOptions(options);
	};

	const fetchVMOffers = async (os: string) => {
		const offers = await subscriptionService.getAllOffersByPublisherInSubscription(
			subscription.id,
			stateFormHandler().location.value,
			stateFormHandler().publisher.value,
			os
		);
		const options = [];
		offers.map(res => options.push({ value: res.name, text: res.name }));
		setOffersOptions(options);
	};

	const fetchSKUs = async (os: string) => {
		const SKUs = await subscriptionService.getAllSKUsByOfferInSubscription(
			subscription.id,
			stateFormHandler().location.value,
			stateFormHandler().publisher.value,
			stateFormHandler().offer.value,
			os
		);
		const options = [];
		SKUs.map(res => options.push({ value: res.name, text: res.name }));
		setSKUsOptions(options);
	};

	const fetchVMSizes = async () => {
		const sizes = await subscriptionService.getAllSizeInSubscription(
			subscription.id,
			stateFormHandler().location.value
		);
		const options = [];
		sizes.map(res => options.push({ value: res.name, text: res.name }));
		setVMSizesOptions(options);
	};

	const fetchSubnets = async (optionSelected: string) => {
		const vNetSelected = vNets?.find(element => element.id == optionSelected)
		const options = [];
		vNetSelected?.properties.subnets.map(res => {
			if (res.properties.delegations.length == 0) options.push({ value: res.name, text: res.name })
		});
		setSubnetsOptions(options);
	};

	const fetchData = async () => {
		setLoading(true);
		const id = parseInt(subsId);
		try {
			const subs = new SubscriptionRequest(await subscriptionService.getById(id));
			setSubscription(subs);
			let resourceGroupName = '';
			const resourcesOptions = [];
			const resources = await subscriptionService.getAllResourceGroupsInSubscription(id, true);
			resources.map(res => {
				(!res.name.includes("managed-resources")) ? resourcesOptions.push({ value: res.name, text: res.name }) : resourceGroupName = res.name;
			});
			setResoruceGroupsOptions(resourcesOptions);
			const vNets = await subscriptionService.getAddressSpacesByResourceGroup(id, resourceGroupName);
			setVNets(vNets);
			const options = [];
			vNets.map(res =>
				options.push({ value: res.id, text: res.name })
			);
			setVNetOptions(options);
			setState({
				...state, stateForm:
				{
					...state.stateForm,
					subscriptionName: subs.createdSubscriptionName,
				}
			});
			handleStateFormChange('subscriptionName', subs.createdSubscriptionName);
			await fetchRecoveryServicesBySubscription();
			setLoading(false);
		} catch (err) {
			const exception = new Exception(err);
			handleEndModal(`An error ocurred. ${exception.response.data.message}.`, 'error', 10000);
		}
	};

	const handleEndModal = (text: string, variant: AlertVariant, timeout: number) => {
		setEndModal({
			visible: true,
			text,
			variant,
		});
		setTimeout(() => endAndRedirect(), timeout);
	};

	const endAndRedirect = () => {
		setEndModal({ visible: false });
		navigate('/');
	};

	const getLinkTree = (): LinkTreeItem[] => {
		return [
			{ text: 'Subscriptions', to: '/subscriptions' },
			{ text: subscription?.createdSubscriptionName, to: `/subscriptions/${subscription?.id}` },
			{ text: 'Virtual Machine Requests', to: `/subscriptions/${subscription?.id}/virtualMachineRequestHistory` }
		];
	};

	const getVMFinalName = (vmNumber: string): string => {
		const form = state.stateForm;
		const env = {
			Production: 'prd',
			Development: 'dev',
			Acceptance: 'act',
			Test: 'tst',
		}
		const location = {
			chinanorth1: 'cnn1',
			chinanorth2: 'cnn2',
			chinanorth3: 'cnn3',
		}
		const fieldsValues = [location[form.location], form.serverNamePrefix.slice(0, 3), ("00" + vmNumber).slice(-3), env[form.environment], 'vm'];
		const filledFields = fieldsValues.filter(field => !!field);
		return filledFields.join('');
	};

	const isValid = (): boolean => {
		return Object.keys(stateFormHandler()).every((key) => {
			const field = stateFormHandler()[key];
			if (!(field.validation.required())) return true;
			return (field.value == '') ? false : true;
		});
	};

	const handleSubmissionAlertClose = () => {
		setSubmissionAlert({
			visible: false
		});
	};

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		if (state?.stateForm?.environment == 'Production')
			setAzureBackupOptions([{ value: 'Enable', text: 'Enabled' }])
		else if (state?.stateForm?.environment == 'Acceptance' && (state?.stateForm?.serviceLevel == '0' || state?.stateForm?.serviceLevel == '1')) {
			setAzureBackupOptions([{ value: 'Enable', text: 'Enabled' }])
		} else
			setAzureBackupOptions([
				{ value: 'Enable', text: 'Enabled' },
				{ value: 'Disable', text: 'Disabled' }
			]);
	}, [state?.stateForm?.environment, state?.stateForm?.serviceLevel]);

	return (
		<>
			<RequestFormWrapper
				title={"New Virtual Machine Request"}
				linkTree={getLinkTree()}
				loading={loading}
			>
				{loadingPermissions.visible &&
					<ProgressBar
						label={loadingPermissions.text}
						className="em-u-margin-top-half"
						indeterminate
						hideValueLabel
					/>}
				{submissionAlert.visible &&
					<Alert
						variant={submissionAlert.variant}
						onClose={handleSubmissionAlertClose}
					>
						{submissionAlert.text}
					</Alert>}
				<Grid variant="halves">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Subscription'}
							{...stateFormHandler().subscriptionName}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Resource Group'}
							{...stateFormHandler().resourceGroups}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="2-up">
					<Grid.Item>
						<TextInputField
							label={'Application Name'}
							{...stateFormHandler().applicationName}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Environment'}
							{...stateFormHandler().environment}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="2-up">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Virtual Network'}
							{...stateFormHandler().virtualNetwork}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Subnet'}
							{...stateFormHandler().subnetName}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="3-up">
					<Grid.Item>
						<TextInputField
							label={'Server Name Prefix'}
							{...stateFormHandler().serverNamePrefix}
						/>
					</Grid.Item>
					<Grid.Item>
						<TextInputField
							label={'Number of VMs'}
							{...stateFormHandler().numberOfVMs}
						/>
					</Grid.Item>
					<Grid.Item>
						<TextInputField
							label={'Starting Number'}
							{...stateFormHandler().startingNumber}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="3-up">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Service Level'}
							{...stateFormHandler().serviceLevel}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'VM Location'}
							{...stateFormHandler().location}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'VM Size'}
							{...stateFormHandler().vmSize}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="3-up">
					{stateFormHandler().publisher.loading && !stateFormHandler().publisher.disabled
						?
						<Grid.Item>
							<ProgressBar
								label={stateFormHandler().publisher.loadingText}
								className="em-u-margin-top-half"
								indeterminate
								hideValueLabel
							/>
						</Grid.Item>
						:
						<Grid.Item>
							<SelectField
								className="em-u-margin-bottom-none dropdown-filter-color full-width"
								label={'VM Image Publisher'}
								{...stateFormHandler().publisher}
							/>
						</Grid.Item>}
					{stateFormHandler().offer.loading && !stateFormHandler().offer.disabled
						?
						<Grid.Item>
							<ProgressBar
								label={stateFormHandler().offer.loadingText}
								className="em-u-margin-top-half"
								indeterminate
								hideValueLabel
							/>
						</Grid.Item>
						:
						<Grid.Item>
							<SelectField
								className="full-width"
								label={'VM Image Offer'}
								{...stateFormHandler().offer}
							/>
						</Grid.Item>}
					{stateFormHandler().SKU.loading && !stateFormHandler().SKU.disabled
						?
						<Grid.Item>
							<ProgressBar
								label={stateFormHandler().SKU.loadingText}
								className="em-u-margin-top-half"
								indeterminate
								hideValueLabel
							/>
						</Grid.Item>
						:
						<Grid.Item>
							<SelectField
								className="full-width"
								label={`${operatingSystemSelected} == 'Windows'` ? 'VM Image SKUs' : 'VM Image Version'}
								{...stateFormHandler().SKU}
							/>
						</Grid.Item>}
				</Grid>
				{showVMName &&
					<Alert
						onClose={() => setShowVMName(false)}
					>
						The VM name will look like: {getVMFinalName(stateFormHandler().startingNumber.value.toLocaleString())}
						<br />
						{"<4 characters location><3 characters App's name><3 digit running number><3 character environment>vm"}
					</Alert>}
				<Grid variant="2-up">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Disk Type'}
							{...stateFormHandler().diskType}
						/>
					</Grid.Item>
					<Grid.Item>
						<div className="em-c-field em-is-valid em-c-field--date-picker full-width">
							<label className="em-c-field__label">Disk Size</label>
							<Select
								isSearchable={false}
								styles={VMStyles}
								className="react-select-container full-width"
								classNamePrefix="react-select"
								components={{ Option: CustomOptionDiskSize }}
								{...stateFormHandler().diskSize}
							/>
						</div>
					</Grid.Item>
				</Grid>
				<Grid variant="2-up">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Availability Options'}
							{...stateFormHandler().availabilityOption}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'Availability Zone'}
							{...stateFormHandler().availabilityZone}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="halves">
					<Grid.Item>
						<ToggleField
							label={'Azure Backup'}
							{...stateFormHandler().azureBackup}
						/>
					</Grid.Item>
				</Grid>
				{stateFormHandler().azureBackup.value == 'Enable' &&
					<Grid variant="2-up">
						<Grid.Item>
							<SelectField
								className="full-width"
								label={'Recovery Services'}
								{...stateFormHandler().recoveryServices}
							/>
						</Grid.Item>
						<Grid.Item>
							<SelectField
								className="full-width"
								label={'Backup Policy'}
								{...stateFormHandler().backupPolicy}
							/>
						</Grid.Item>
					</Grid>}
				<Grid variant="2-up">
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'VM Patching'}
							{...stateFormHandler().patchMode}
						/>
					</Grid.Item>
					<Grid.Item>
						<SelectField
							className="full-width"
							label={'VM Patching Schedule'}
							{...stateFormHandler().patchSchedule}
						/>
					</Grid.Item>
				</Grid>
				<Grid variant="3-up">
					<Grid.Item />
					<Grid.Item />
					<Grid.Item>
						<ReactButton
							name={'Submit Request'}
							isLoading={loading}
							variant={"default"}
							handleUpdateSubmit={() => handleSubmitRequest()}
							disabled={!isValid() || loading}
							loadingVariant={"default"}
						/>
					</Grid.Item>
				</Grid>
			</RequestFormWrapper>
			<AlertModal {...endModal} willTimeout={false} onClose={endAndRedirect} />
		</>
	);
};

export default VirtualMachineRequestCreate;